// DTM
import React, { Component } from "react";
import styled from "styled-components";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  padding: 50px 0 25px 0;
  float: left;
  width: 100%;
  display: flex;
  justify-content: center;

  @media (max-width: 1100px) {
    position: relative;
    display: block;
    padding: 40px 0 27px 0;
  }
  @media (max-width: 700px) {
    padding: 0 0 40px 0;
    width: calc(100% - 46px);
    margin: 0 23px;
  }
`;
const Text = styled.div`
  width: 180px;
  padding-right: 25px;

  @media (max-width: 1100px) {
    width: 100%;
    padding: 0;
  }
`;
const Title = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.85);

  padding-bottom: 21px;

  @media (max-width: 1100px) {
    width: 100%;
    float: left;

    height: 23px;
    line-height: 1.44;
    text-align: center;

    padding-bottom: 0;
  }
  @media (max-width: 700px) {
    margin: 40px 0 50px 0;

    height: auto;
    font-size: 16px;
    line-height: 1.44;
    letter-spacing: 1px;
  }
`;
const Body = styled.div`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.14;
  letter-spacing: 0.9px;
  color: #000000;

  @media (max-width: 1100px) {
    padding: 202px 25px 27px 25px;
    width: calc(100% - 50px);

    height: 28px;

    font-size: 13px;

    line-height: 2.15;
    letter-spacing: 0.8px;
    text-align: center;
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 700px) {
    display: flex;
    width: 100%;
    padding: 0;
    margin: 0;
    height: auto;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
const Items = styled.div`
  width: 836px;
  height: 179px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1100px) {
    position: absolute;
    top: 98px;
    left: 25px;
    width: calc(100% - 50px);

    height: 157px;

    display: flex;
    justify-content: space-between;

    @media (max-width: 700px) {
      position: absolute;
      width: 100%;
      top: 113px;
      left: 0;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
`;
const Line = styled.div`
  width: 100%;

  @media (max-width: 1100px) {
    width: 157px;
    height: 28px;
  }
  @media (max-width: 700px) {
    width: 128px;

    font-family: Lato;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    text-align: center;

    margin-top: 152px;
    margin-bottom: 17px;

    :nth-child(2n + 1) {
      margin-right: calc(50% - 129px);
    }
    :nth-child(2n) {
      margin-left: calc(50% - 129px);
    }
  }
`;

class ServiceLine extends ArticleAbstract {
  render() {
    return <Line {...this.link()}>{this.title()}</Line>;
  }
}

class SetServices extends Component {
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Text>
          <Title>{first.title}</Title>
          <Body>{items.map(item => <ServiceLine key={item.id} content={item} />)}</Body>
        </Text>
        <Items>{items.map(item => <Service key={item.id} content={item} />)}</Items>
      </Wrapper>
    );
  }
}

export default SetServices;

const Item = styled.div`
  width: 179px;
  height: 179px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;

  @media (max-width: 1100px) {
    width: 157px;
    height: 157px;
  }
  @media (max-width: 700px) {
    width: 128px;
    height: 128px;

    margin-top: 12px;
    margin-bottom: 57px;

    :nth-child(2n + 1) {
      margin-right: calc(50% - 129px);
    }
    :nth-child(2n) {
      margin-left: calc(50% - 129px);
    }
  }
`;

class Service extends ArticleAbstract {
  render() {
    return <Item {...this.link(this.image())} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/SetServices.js